/*

Envy by WeTheme (http://www.wetheme.com)
Custom JS also by Adam Jones (http://www.adam-makes-websites.com)
Last Updated: 14/08/2026
*/

var country = (document.documentElement.dataset.country || '').toUpperCase();


$(document).ready(function() {
	
  	// append tax/duties statement to selected items in cart
    if (country !== 'US') {
        $('body').observe('added', '#cart-price .money', function(record) {
            $("#cart-price .money").append('<span class="withVAT"> EXCL. VAT</span>');
        });
    }
    
  
  	// check for change of every product variant drop down and then check if that new selection is available and update price/sold out msg
    // Note: class names can vary in case (Size vs size, Color vs color) so we listen for both
    $(document).on('change','.selector-option-Size, .selector-option-size', function(event){
      updateSoldOutPrice();
    });
  	$(document).on('change','.selector-option-Color, .selector-option-color', function(event){
      updateSoldOutPrice();
    });
 	$(document).on('change','.selector-option-Colour, .selector-option-colour', function(event){
      updateSoldOutPrice();
    });
    $(document).on('change','.selector-option-Metal, .selector-option-metal', function(event){
      updateSoldOutPrice();
    });
    $(document).on('change','.selector-option-Pearl, .selector-option-pearl', function(event){
      updateSoldOutPrice();
    });
    // Also listen for clicks on the custom sod_select dropdown options (theme's styled select)
    $(document).on('click', '.sod_option', function(event){
      // Small delay to let the theme's JS update the underlying select first
      setTimeout(updateSoldOutPrice, 50);
    });
  
    // setup popup for out of stock notification
    $(".stockNotifyBtn, #noStockAtAllBtn").fancybox({
		maxWidth	: 800,
		maxHeight	: 600,
		fitToView	: false,
		width		: '70%',
		height		: '70%',
		autoSize	: false,
		closeClick	: false,
		openEffect	: 'none',
		closeEffect	: 'none'
	});


    // lightbox for products
   const $dynamicGallery = document.getElementById('product_images');
   if ($dynamicGallery && typeof lightGallery !== 'undefined') {
     const galleryPlugins = [lgZoom];
     if (typeof lgVideo !== 'undefined') {
       galleryPlugins.push(lgVideo);
     }

     const dynamicGallery = lightGallery($dynamicGallery, {
          speed: 300,
          selector: '.image-swap',
          plugins: galleryPlugins,
          download: false,
          autoplayFirstVideo: true,
          autoplayVideoOnSlide: true,
          gotoNextSlideOnVideoEnd: false
      });

      $(document).on('click','.masterImage', function(event){
        if ($(this).hasClass('hide') || !$(this).is(':visible')) {
          return;
        }
        dynamicGallery.openGallery();
      });

      var matchVideoThumbSize = function() {
        var $firstImage = $('#product-thumbnails a.image-swap:not(.product-video-thumb) img').first();
        var $videoThumbs = $('#product-thumbnails .product-video-thumb');
        if (!$firstImage.length || !$videoThumbs.length) {
          return;
        }
        var width = $firstImage.outerWidth();
        var height = $firstImage.outerHeight();
        if (width > 0 && height > 0) {
          $videoThumbs.css('aspect-ratio', width + ' / ' + height);
        }
      };
      matchVideoThumbSize();
      $(window).on('load resize', matchVideoThumbSize);
   }


    // sizing page jump links 
    $('.styleindextable a[href^="#"]').on('click', function(e) {
        e.preventDefault();
        var target = $(this.getAttribute('href'));
        if(target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top - 80
            }, 500);
        }
    });
  
});





$(window).load(function() {
    // add vat to products page, needs doing after page load due to prices in theme loading via ajax
	if ($("body").hasClass("template-product") || $("body").hasClass("template-cart")) {
  		if (window.location.href.indexOf("collections/books") > -1) {
			console.log("Product page thats a book found, not adding VAT msg");
        }else{
            if (country !== 'US') {
          	    $(".cart-item-price .money, #cart-total-final-price .money").append('<span class="withVAT"> EXCL. VAT</span>');
			    console.log("VAT Msg being added");
            }
        }
 	}
  	
  	markSoldOutVariantsSelect();	// iterate through variants select and add class to sold out ones
    updateSoldOutPrice();			// check if default selected variant is sold out and mark on price if it is
  	
});

// Responsive tables init
$(document).ready(function() {
	$('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
});

// Wow Animation init
$(document).ready(function() {
  new WOW().init();
});

// Mobile Browser Menu
$("select#mobile-menu").change(function() {
  window.location = $(this).find("option:selected").val();
});

// FancyBox
$(document).ready(function() {
	$(".fancybox").fancybox();
});

$(document).ready(function() {
	$(".fancybox-instagram").fancybox({
		padding : 0
	});
});

// Login Boxes
$("#forgot-password-box").click(function(){
    $("#customer-login").hide();
    $("#recover-password").show();
});

$("#login-box-link").click(function(){
	$("#customer-login").show();
	$("#recover-password").hide();
});

// Drawers
var MOBILE_DRAWER_SIZE = 300,
    DESKTOP_DRAWER_SIZE = 390,
    MOBILE_WIDTH_MAX = 860;

window.slideouts = {};


// Simulate responsiveness of the Drawer component
$(window).resize(function () {
    var is_mobile = document.body.clientWidth < MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    window.slideouts.left._touch = is_mobile;

    // Resize right drawer based on window width
    var slideout = window.slideouts.right,
        padding = (is_mobile) ? MOBILE_DRAWER_SIZE : DESKTOP_DRAWER_SIZE;
    slideout._translateTo = slideout._padding = padding * slideout._orientation;
    if (slideout._opened) {
        var transform = "translateX(" + (padding * slideout._orientation) + "px)";
        slideout.panel.style.webkitTransform = transform;
        slideout.panel.style.transform = transform;
    }
});



function updateSoldOutPrice() {
    // Created: 8/10/20
    // Updated: 2025-05-13 (Handles varying order in data-name for Color/Size)

    // Desc: Runs on prod page load/variant to check if selected combo is sold out.
    // - If 'productVariantDebug' in localStorage is 'true', a table of all variants and their status is shown.
    // - If the selected combo is sold out:
    //   - 'SOLD OUT' is prefixed to the price.
    //   - A stock notify button is added.

    // --- Debug Table Logic ---
    const isDebugMode = localStorage.getItem('productVariantDebug') === 'true';
    const debugTableContainerId = 'variant-debug-table-container';
    $('#' + debugTableContainerId).remove();

    if (isDebugMode) {
        console.log("updateSoldOutPrice() - DEBUG MODE ACTIVE (localStorage)");
        const $mainProductSelectForDebug = $("#ProductSelect-product-template");
        if ($mainProductSelectForDebug.length) {
            let debugTableHTML = `
                <div id="${debugTableContainerId}" style="margin-top: 20px; border: 1px solid #ccc; padding: 10px; background-color: #f9f9f9; font-family: monospace; color: #333;">
                    <h3 style="margin-top:0; margin-bottom: 10px; color: #111;">Variant Debug Information</h3>
                    <p style="font-size: 11px; margin-bottom: 15px;">To disable, type in console: <code style="background-color: #e0e0e0; padding: 2px 4px; border-radius: 3px;">localStorage.removeItem('productVariantDebug');</code> and reload/re-trigger.</p>
                    <table border="1" style="width:100%; border-collapse: collapse; font-size: 12px; table-layout: fixed;">
                        <thead style="background-color: #eee;">
                            <tr>
                                <th style="padding: 5px; width: 25%;">Original Text</th>
                                <th style="padding: 5px; width: 20%;">Data-Name</th>
                                <th style="padding: 5px; width: 10%;">Parsed Size (Debug)</th>
                                <th style="padding: 5px; width: 15%;">Parsed Colour (Debug)</th>
                                <th style="padding: 5px; width: 8%;">Price</th>
                                <th style="padding: 5px; width: 7%;">Disabled?</th>
                                <th style="padding: 5px; width: 8%;">"Sold Out" Text?</th>
                                <th style="padding: 5px; width: 12%;">Calculated Availability</th>
                            </tr>
                        </thead>
                        <tbody>
            `;
            $mainProductSelectForDebug.find("option").each(function() {
                const $option = $(this);
                const optionText = $option.text().trim();
                const dataNameRaw = $option.data("name");
                const dataName = (dataNameRaw !== undefined && dataNameRaw !== null) ? String(dataNameRaw) : "N/A";
                const price = $option.data("price") || "N/A";
                const isDisabled = $option.is(':disabled');
                const hasSoldOutText = optionText.includes(" - Sold Out");
                const isAvailable = !isDisabled && !hasSoldOutText;
                let parsedDebugSize = "N/A"; // For debug table display only
                let parsedDebugColour = "N/A"; // For debug table display only
                if (dataName !== "N/A") {
                    const parts = dataName.split(" / ");
                    // This parsing is a simple split for the debug table; it might not always
                    // correctly label "Size" vs "Color" if the order varies and isn't known.
                    // The core logic uses currentSize/currentColour from selectors.
                    parsedDebugSize = parts[0] ? parts[0].trim() : "N/A";
                    if (parts.length > 1) {
                        parsedDebugColour = parts.slice(1).join(" / ").trim();
                    }
                }
                debugTableHTML += `
                    <tr style="background-color: ${isAvailable ? '#e6ffe6' : '#ffe6e6'};">
                        <td style="padding: 4px; word-wrap: break-word;">${optionText}</td>
                        <td style="padding: 4px; word-wrap: break-word;">${dataName}</td>
                        <td style="padding: 4px; word-wrap: break-word;">${parsedDebugSize}</td>
                        <td style="padding: 4px; word-wrap: break-word;">${parsedDebugColour}</td>
                        <td style="padding: 4px;">${price}</td>
                        <td style="padding: 4px; text-align: center;">${isDisabled ? 'Yes' : 'No'}</td>
                        <td style="padding: 4px; text-align: center;">${hasSoldOutText ? 'Yes' : 'No'}</td>
                        <td style="padding: 4px; font-weight: bold; color: ${isAvailable ? 'green' : 'red'}; text-align: center;">${isAvailable ? 'Available' : 'SOLD OUT'}</td>
                    </tr>
                `;
            });
            debugTableHTML += '</tbody></table></div>';
            if ($(".product-form").length) {
                 $(".product-form").first().prepend(debugTableHTML);
            } else if ($("#purchase").length) {
                 $("#purchase").parent().prepend(debugTableHTML);
            } else {
                $('body').prepend(debugTableHTML);
            }
        } else {
            console.log("updateSoldOutPrice() - DEBUG: #ProductSelect-product-template not found for debug table.");
        }
    }

    $(".stockNotifyBtn").remove();
    const $priceField = $("#price-field");
    $priceField.find('.withVAT').remove();

    var currentSize = "";
    var currentColour = "";
    // Check both capitalized and lowercase class names for size selector
    var $sizeSelectedOption = $(".selector-option-Size option:selected, .selector-option-size option:selected").first();
    if ($sizeSelectedOption.length && $sizeSelectedOption.val() && $sizeSelectedOption.val().toLowerCase() !== "select size" && $sizeSelectedOption.val() !== "Default Title") {
        currentSize = $sizeSelectedOption.val();
    }
    // Check both capitalized and lowercase class names for color selector
    var $colorSelectedOption = $(".selector-option-Color option:selected, .selector-option-color option:selected").first();
    if ($colorSelectedOption.length && $colorSelectedOption.val() && $colorSelectedOption.val().toLowerCase() !== "select color" && $colorSelectedOption.val() !== "Default Title") {
        currentColour = $colorSelectedOption.val();
    } else {
        var $colourSelectedOption = $(".selector-option-Colour option:selected, .selector-option-colour option:selected").first();
        if ($colourSelectedOption.length && $colourSelectedOption.val() && $colourSelectedOption.val().toLowerCase() !== "select colour" && $colourSelectedOption.val() !== "Default Title") {
            currentColour = $colourSelectedOption.val();
        }
    }
    console.log("updateSoldOutPrice() initial selections: Size='" + currentSize + "', Colour='" + currentColour + "'");

    var markSoldOut = false;
    var price = "N/A";
    var $mainProductSelect = $("#ProductSelect-product-template");
    let finalDisplaySize = currentSize;
    let finalDisplayColour = currentColour;

    if ($mainProductSelect.length) {
        let $chosenOption = null;

        // Case 1: Both Size and Colour are selected by the user
        if (currentSize && currentColour) {
            // Construct potential data-name strings in both orders
            const targetDataNameOrder1 = currentSize + " / " + currentColour; // e.g., "Small (46) / Khaki"
            const targetDataNameOrder2 = currentColour + " / " + currentSize; // e.g., "Khaki / Small (46)"

            console.log("updateSoldOutPrice() [Exact Match]: Trying data-name: '" + targetDataNameOrder1 + "'");
            $chosenOption = $mainProductSelect.find("option[data-name='" + targetDataNameOrder1 + "']").first();

            if (!$chosenOption.length) { // If first order didn't match, try the second order
                console.log("updateSoldOutPrice() [Exact Match]: Variant '" + targetDataNameOrder1 + "' not found. Trying alternate order: '" + targetDataNameOrder2 + "'");
                $chosenOption = $mainProductSelect.find("option[data-name='" + targetDataNameOrder2 + "']").first();
            }

            if (!$chosenOption.length) { // If neither order matched
                markSoldOut = true;
                console.log("updateSoldOutPrice() [Exact Match]: Variant matching EITHER '" + targetDataNameOrder1 + "' OR '" + targetDataNameOrder2 + "' not found in Shopify select. Marked SOLD OUT.");
            } else {
                console.log("updateSoldOutPrice() [Exact Match]: Found variant with data-name: '" + $chosenOption.data("name") + "'");
            }
        }
        // Case 2: Only Colour is selected, Size is not
        else if (currentColour && !currentSize) {
            finalDisplaySize = "Any"; // For messaging
            // This search is broad, might need refinement if color names are substrings of others.
            // It looks for the color string anywhere in the data-name.
            const $allColorOptions = $mainProductSelect.find("option[data-name*='" + currentColour + "']");
            $chosenOption = $allColorOptions.filter(function() {
                return !$(this).text().trim().includes(" - Sold Out") && !$(this).is(':disabled');
            }).first(); // Get the first available one

            if (!$chosenOption.length && $allColorOptions.length) {
                $chosenOption = $allColorOptions.first();
                console.log("updateSoldOutPrice() [Color Only]: No _available_ options for color '" + currentColour + "'. Using first found (which is likely sold out/disabled).");
            } else if (!$chosenOption.length) {
                markSoldOut = true;
                console.log("updateSoldOutPrice() [Color Only]: No variants found at all containing color '" + currentColour + "'. Marked SOLD OUT.");
            }
        }
        // Case 3: Only Size is selected, Colour is not (or product has no color option)
        else if (currentSize && !currentColour) {
            finalDisplayColour = "N/A";
            console.log("updateSoldOutPrice() [Size Only]: Attempting to find exact data-name match for size: '" + currentSize + "'");
            $chosenOption = $mainProductSelect.find("option[data-name='" + currentSize + "']").first(); // For size-only products

            if (!$chosenOption.length) {
                console.log("updateSoldOutPrice() [Size Only]: Exact data-name match failed for '" + currentSize + "'. Fallback: Trying prefix search data-name^='" + currentSize + " /'");
                const $allSizeOptions = $mainProductSelect.find("option[data-name^='" + currentSize + " /']"); // For "Size / Color" products
                $chosenOption = $allSizeOptions.filter(function() {
                    return !$(this).text().trim().includes(" - Sold Out") && !$(this).is(':disabled');
                }).first();

                if (!$chosenOption.length && $allSizeOptions.length) {
                    $chosenOption = $allSizeOptions.first();
                    console.log("updateSoldOutPrice() [Size Only - Prefix Fallback]: No _available_ options for size prefix '" + currentSize + " /'. Using first found.");
                } else if (!$chosenOption.length) {
                     // One more attempt: if data-name ends with " / Size" (like "Color / Size")
                    console.log("updateSoldOutPrice() [Size Only - Prefix Fallback]: Trying suffix search data-name$=' / " + currentSize + "']");
                    const $allSizeOptionsSuffix = $mainProductSelect.find("option[data-name$=' / " + currentSize + "']");
                    $chosenOption = $allSizeOptionsSuffix.filter(function() {
                        return !$(this).text().trim().includes(" - Sold Out") && !$(this).is(':disabled');
                    }).first();
                     if (!$chosenOption.length && $allSizeOptionsSuffix.length) {
                        $chosenOption = $allSizeOptionsSuffix.first();
                        console.log("updateSoldOutPrice() [Size Only - Suffix Fallback]: No _available_ options for size suffix ' / " + currentSize + "'. Using first found.");
                    } else if (!$chosenOption.length) {
                        markSoldOut = true;
                        console.log("updateSoldOutPrice() [Size Only - All Fallbacks Failed]: No variants found for size '" + currentSize + "'. Marked SOLD OUT.");
                    }
                }
            } else {
                console.log("updateSoldOutPrice() [Size Only]: Found exact data-name match for '" + currentSize + "'.");
            }
        }
        // Case 4: Neither Size nor Colour is selected by the user
        else {
            console.log("updateSoldOutPrice() [No User Selection]: Checking Shopify select's default/current option.");
            $chosenOption = $mainProductSelect.find("option:selected").first();
            var dataNameVal = $chosenOption.length ? $chosenOption.data("name") : null;
            if (dataNameVal !== undefined && dataNameVal !== null) {
                const nameParts = String(dataNameVal).split(" / ");
                finalDisplaySize = nameParts[0] ? nameParts[0].trim() : (currentSize || "Selected");
                if (nameParts.length > 1) {
                    finalDisplayColour = nameParts.slice(1).join(" / ").trim();
                } else {
                    finalDisplayColour = (currentColour || "Variant"); // Could be a size-only product
                }
            } else if ($chosenOption.length) {
                // No data-name but option exists - likely a simple product without variants
                // Don't mark as sold out here; let the analysis section below check availability
                console.log("updateSoldOutPrice() [No User Selection]: Option found but no data-name. Will check availability in analysis section.");
                finalDisplaySize = "Default";
                finalDisplayColour = "N/A";
            } else {
                markSoldOut = true;
                console.log("updateSoldOutPrice() [No User Selection]: No valid default option in Shopify select. Marked SOLD OUT.");
            }
        }

        // --- Analyze the $chosenOption (if one was determined by the logic above) ---
        if ($chosenOption && $chosenOption.length) {
            const optionText = $chosenOption.text().trim();
            price = $chosenOption.data("price") || "N/A";
            if (optionText.includes(" - Sold Out") || $chosenOption.is(':disabled')) {
                markSoldOut = true;
                console.log("updateSoldOutPrice() [Option Analysis]: Variant '" + ($chosenOption.data("name") || optionText) + "' is SOLD OUT or disabled.");
            } else {
                markSoldOut = false;
                console.log("updateSoldOutPrice() [Option Analysis]: Variant '" + ($chosenOption.data("name") || optionText) + "' is AVAILABLE.");
            }
            // Update display names from the actual chosen Shopify option if they were initially "Any" or "N/A"
            // This part is tricky if data-name order varies. User-selected currentSize/currentColour are preferred.
            var chosenDataName = $chosenOption.data("name");
            if ((finalDisplaySize === "Any" || !finalDisplaySize) && chosenDataName !== undefined && chosenDataName !== null) {
                // Attempt to infer, but this is non-trivial if order varies and not all parts are present
                // For now, if currentSize was set, it remains. If not, this is a best guess.
                 const nameParts = String(chosenDataName).split(" / ");
                 // Heuristic: if currentSize was not set by user, and data-name has parts, assume one is size.
                 // This won't be perfect for all data-name structures.
                 if (!currentSize) finalDisplaySize = nameParts[0].trim(); // Default to first part if currentSize was empty
            }
            if ((finalDisplayColour === "Any" || finalDisplayColour === "N/A" || !finalDisplayColour) && chosenDataName !== undefined && chosenDataName !== null) {
                const nameParts = String(chosenDataName).split(" / ");
                if (!currentColour) { // Only infer if user didn't select a color
                    if (nameParts.length > 1) {
                        finalDisplayColour = nameParts.slice(1).join(" / ").trim(); // Default to second part if currentColour was empty
                    } else if (!nameParts[0].includes(currentSize)) { // If single part data-name and it's not the size
                        finalDisplayColour = nameParts[0].trim();
                    } else {
                        finalDisplayColour = "N/A";
                    }
                }
            }

        } else if (!markSoldOut) {
            markSoldOut = true;
            console.log("updateSoldOutPrice(): No specific matching variant found in Shopify select. Defaulting to SOLD OUT.");
        }

        // --- Update the Price Field and Add 'Notify Me' Button based on markSoldOut status ---
        if (markSoldOut) {
            let logColour = (finalDisplayColour === "N/A" || !finalDisplayColour) ? "" : finalDisplayColour + " / ";
            console.log("updateSoldOutPrice() - CONCLUSION: Marking (" + logColour + (finalDisplaySize || "N/A") + ") as SOLD OUT! Price: " + price);
            $priceField.html("SOLD OUT - (" + price + ")");
            var prodName = $(".product-description-header").html() || "Selected Product";
            var variantInfoForLink = "";
            // Use currentSize and currentColour for the link if available, as they reflect user's direct selection
            let linkSize = currentSize || finalDisplaySize;
            linkSize = (linkSize === "Any" || !linkSize) ? "" : linkSize;
            let linkColour = currentColour || finalDisplayColour;
            linkColour = (linkColour === "Any" || !linkColour || linkColour === "N/A") ? "" : linkColour;

            if (linkSize && linkColour) { // Prefer "Color / Size" or "Size / Color" based on what was matched or typical
                 // Heuristic: if data-name of chosen option starts with color, use that order
                var chosenDataNameForLink = $chosenOption && $chosenOption.length ? $chosenOption.data("name") : null;
                if (chosenDataNameForLink !== null && chosenDataNameForLink !== undefined && String(chosenDataNameForLink).startsWith(linkColour)) {
                    variantInfoForLink = linkColour + " / " + linkSize;
                } else {
                    variantInfoForLink = linkSize + " / " + linkColour; // Default to Size / Color
                }
            } else if (linkSize) {
                variantInfoForLink = linkSize;
            } else if (linkColour) {
                variantInfoForLink = linkColour;
            }

            $("#purchase").after('<span class="btn envyBtn stockNotifyBtn" data-fancybox-type="iframe" href="https://simon.mfs.gg/XOVJ4zu?text_4678=' + encodeURIComponent(prodName) + '&variant=' + encodeURIComponent(variantInfoForLink) + '">Please click here to join the waiting list, and be notified when this product is back in stock</span>');
        } else {
            let conclusionColour = (finalDisplayColour === "N/A" || !finalDisplayColour) ? "" : finalDisplayColour + " - ";
            console.log("updateSoldOutPrice() - CONCLUSION: Option (" + conclusionColour + (finalDisplaySize || "N/A") + ") NOT sold out. Price: " + price);
            if (price === "N/A") {
                $priceField.html('Price unavailable');
            } else {
                $priceField.html(price);
            }

            if (country !== 'US') {
                $priceField.append('<span class="withVAT"> EXCL. VAT</span>');
            }
        }
    } else {
        console.log("updateSoldOutPrice(): Main product select '#ProductSelect-product-template' not found. Nothing to do.");
        $priceField.html("Product information unavailable.");
    }
}




function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // Escapes special characters
}


function isFullMatch(stringToMatch, thePattern) {
    var escapedPattern = thePattern.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // Escape special regex chars
    // Ensure thePattern matches as a whole word directly adjacent to spaces, slashes, or dashes
    var re = new RegExp("(^|\\s|/|-)"+escapedPattern+"(\\s|/|-|$)", "i");
    return re.test(stringToMatch.trim()) && !new RegExp(`(?:/|-)\\s*\\w+\\s+${escapedPattern}`, "i").test(stringToMatch.trim());
}


function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}


function markSoldOutVariantsSelect(){
  	// Created: 8/10/20 : AJ
    // Updated: 13/10/20
	// Adds a class to the variants selector to mark sold out items differently so they can be shaded in another style
  	
  	console.log("Iterating product options looking for sold out...");
  	$("#ProductSelect-product-template option").each(function(i){
      var currentLabel=$(this).text().trim();
      var currentNameRaw = $(this).data("name");
      // Safety check: ensure data-name exists and is a string before trimming
      if (currentNameRaw === undefined || currentNameRaw === null) {
        console.log("Skipping option with no data-name attribute");
        return; // Skip this option, continue to next
      }
      var currentName = String(currentNameRaw).trim();
      
      // if we have colours explode and get just the size
      if (currentName.includes(" / ")){
        currentName=currentName.split(" / ");
        currentName=currentName[1];
      }
      
      console.log(currentLabel);
      
      if (currentLabel.includes(" - Sold Out")){
        // iterate through envy themes alternative select variants
      	$(".sod_list span").each(function(i){
          var currentEnvyLabel=$(this).text().trim();
          console.log("checking envy select list for same name as this label ("+currentName+"), we found: "+currentEnvyLabel);
          
          if (currentEnvyLabel.includes(currentName)){
            //$(this).css('opacity', '0.4');
            //$(this).append(" - SOLD OUT");
          }else{
            console.log("not included");
          }
        });
      }
    });
	
}



function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        padding = DESKTOP_DRAWER_SIZE;
    }

    var slideout = new Slideout({
        'panel': panel,
        'menu': menu,
        'padding': padding,
        'tolerance': 70,
        'side': side,
        'touch': false
    });
    var dir = (side === 'right') ? -1 : 1;
    window.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    var $overlay = $(overlay);
    overlay.addEventListener('click', slideout.close.bind(slideout));

    // Handle slide to close
    var touch_start = null;
    overlay.addEventListener('touchstart', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        event.preventDefault();
        touch_start = event.touches[0].pageX;
    });
    overlay.addEventListener('touchmove', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.touches[0].pageX;
        var translate = (dir * padding) - offset;
        if (Math.abs(translate) > padding) {
            translate = (dir * padding);
        }
        panel.style.webkitTransform ='translateX(' + translate + 'px)';
        panel.style.transform ='translateX(' + translate + 'px)';
    });
    overlay.addEventListener('touchend', function (event) {
        if (!slideout.isOpen()) {
            return;
        }
        var offset = touch_start - event.changedTouches[0].pageX;
        if (offset === 0 || Math.abs(offset) > 70) {
            slideout.close(slideout);
        } else {
            panel.style.webkitTransform = 'translateX(' + (dir * padding) + 'px)';
            panel.style.transform = 'translateX(' + (dir * padding) + 'px)';
        }
    });

    slideout.on('beforeopen', function() {
        menu.classList.remove('slideout-panel-hidden');
        hidden_menu.classList.add('slideout-panel-hidden');
        $overlay.fadeIn();
        // document.body.style.overflowY = 'hidden';
        var marginTop = (-document.body.scrollTop) + 'px';
        panel.style.position = 'fixed';
        panel.style.marginTop = marginTop;
    });

    slideout.on('beforeclose', function () {
        $overlay.fadeOut();
        var scrollTop = -parseInt(panel.style.marginTop);
        panel.style.position = '';
        panel.style.marginTop = '';
        document.body.scrollTop = scrollTop;
    });

    slideout.on('close', function() {
        menu.classList.add('slideout-panel-hidden');
        console.log("Closing - in function");
        $('.navigation-button').css('visibility', 'visible');
    });
    slideout.on('translate', function(translated) {
        var hidden = false;
        if (translated === 0) {
            hidden = true;
        } else if (side === 'left') {
            hidden = translated <= 0;
        } else if (side === 'right') {
            hidden = translated >= 0;
        }
        menu.classList.toggle('slideout-panel-hidden', hidden);
        hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
    });

    return slideout;
}



function load_menu_drawer() {
    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    /* Mobile Menu */

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    document.body.appendChild(left_menu);

    var slideoutLeft = create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').on('click', function() {
        slideoutLeft.toggle();
        console.log("Menu clicked");
    });

    $('.mobile-menu-close').on('click', function () {
        slideoutLeft.close();
        console.log("Menu closed");
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= MOBILE_WIDTH_MAX) {
        slideoutLeft._touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    var slideoutRight = create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').on('click', function (e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function (e) {
        slideoutRight.close();
    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
  
}

$(document).ready(load_menu_drawer);

document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId === 'header') {
        load_menu_drawer();
    } else if (event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function () {
            // Scroll to the footer element after loading
            document.documentElement.scrollTop = document.body.scrollTop = document.body.clientHeight;
        }, 0);
    }
});


/* PS theme imported content */
$(document).ready(function() {

  // ?
  $('#searchform select, #searchform input[type="checkbox"], #searchform input[type="radio"]').change(function() {
    $(this).closest("form").submit();
  });
  
  // catch open action  of slide out menu
  $('.navigation-button').click(function() {
      console.log("opening");
      $('body').toggleClass('no-scroll');       		
      $(this).toggleClass('visible');  
      $('.navigation-overlay').toggleClass('visible');  
      $('.navigation-button').css('visibility', 'hidden');
         		
  });

  // catch close action of slide out menu
  /*
  $('.sidr-close-icon, #slideout-overlay').click(function () {
      console.log("closing");
      $('.navigation-button').show();
      $('body').toggleClass('no-scroll');       		
      $('.navigation-button').toggleClass('visible');  
      $('.search-overlay').toggleClass('visible');
      $(".search-overlay input[type='text']").focus();
    
  });
  */

  $(document).on('click','#slideout-overlay', function(event){
    console.log("ha");
   });
  
});







(function(d){d.Observe={}})(jQuery);
(function(d,q){var r=function(e,f){f||(f=e,e=window.document);var m=[];d(f).each(function(){for(var l=[],g=d(this),h=g.parent();h.length&&!g.is(e);h=h.parent()){var f=g.get(0).tagName.toLowerCase();l.push(f+":eq("+h.children(f).index(g)+")");g=h}(h.length||g.is(e))&&m.push("> "+l.reverse().join(" > "))});return m.join(", ")};q.path={get:r,capture:function(e,f){f||(f=e,e=window.document);var m=[];d(f).each(function(){var l=-1,g=this;if(this instanceof Text)for(var g=this.parentNode,h=g.childNodes,
f=0;f<h.length;f++)if(h[f]===this){l=f;break}var k=r(e,g),n=d(e).is(g);m.push(function(e){e=n?e:d(e).find(k);return-1===l?e:e.contents()[l]})});return function(e){e=e||window.document;return m.reduce(function(d,f){return d.add(f(e))},d([]))}}}})(jQuery,jQuery.Observe);(function(d,q){var r=function(e){this.original=d(e);this.root=this.original.clone(!1,!0)};r.prototype.find=function(d){return q.path.capture(this.original,d)(this.root)};q.Branch=r})(jQuery,jQuery.Observe);
(function(d,q){var r=function(a,b){var c={};a.forEach(function(a){(a=b(a))&&(c[a[0]]=a[1])});return c},e=r("childList attributes characterData subtree attributeOldValue characterDataOldValue attributeFilter".split(" "),function(a){return[a.toLowerCase(),a]}),f=r(Object.keys(e),function(a){if("attributefilter"!==a)return[e[a],!0]}),m=r(["added","removed"],function(a){return[a.toLowerCase(),a]}),l=d([]),g=function(a){if("object"===typeof a)return a;a=a.split(/\s+/);var b={};a.forEach(function(a){a=
a.toLowerCase();if(!e[a]&&!m[a])throw Error("Unknown option "+a);b[e[a]||m[a]]=!0});return b},h=function(a){return"["+Object.keys(a).sort().reduce(function(b,c){var d=a[c]&&"object"===typeof a[c]?h(a[c]):a[c];return b+"["+JSON.stringify(c)+":"+d+"]"},"")+"]"},t=window.MutationObserver||window.WebKitMutationObserver,k=function(a,b,c,s){this._originalOptions=d.extend({},b);b=d.extend({},b);this.attributeFilter=b.attributeFilter;delete b.attributeFilter;c&&(b.subtree=!0);b.childList&&(b.added=!0,b.removed=
!0);if(b.added||b.removed)b.childList=!0;this.target=d(a);this.options=b;this.selector=c;this.handler=s};k.prototype.is=function(a,b,c){return h(this._originalOptions)===h(a)&&this.selector===b&&this.handler===c};k.prototype.match=function(a){var b=this.options,c=a.type;if(!this.options[c])return l;if(this.selector)switch(c){case "attributes":if(!this._matchAttributeFilter(a))break;case "characterData":return this._matchAttributesAndCharacterData(a);case "childList":if(a.addedNodes&&a.addedNodes.length&&
b.added&&(c=this._matchAddedNodes(a),c.length))return c;if(a.removedNodes&&a.removedNodes.length&&b.removed)return this._matchRemovedNodes(a)}else{var s=a.target instanceof Text?d(a.target).parent():d(a.target);if(!b.subtree&&s.get(0)!==this.target.get(0))return l;switch(c){case "attributes":if(!this._matchAttributeFilter(a))break;case "characterData":return this.target;case "childList":if(a.addedNodes&&a.addedNodes.length&&b.added||a.removedNodes&&a.removedNodes.length&&b.removed)return this.target}}return l};
k.prototype._matchAttributesAndCharacterData=function(a){return this._matchSelector(this.target,[a.target])};k.prototype._matchAddedNodes=function(a){return this._matchSelector(this.target,a.addedNodes)};k.prototype._matchRemovedNodes=function(a){var b=new q.Branch(this.target),c=Array.prototype.slice.call(a.removedNodes).map(function(a){return a.cloneNode(!0)});a.previousSibling?b.find(a.previousSibling).after(c):a.nextSibling?b.find(a.nextSibling).before(c):(this.target===a.target?b.root:b.find(a.target)).empty().append(c);
return this._matchSelector(b.root,c).length?d(a.target):l};k.prototype._matchSelector=function(a,b){var c=a.find(this.selector);b=Array.prototype.slice.call(b);return c=c.filter(function(){var a=this;return b.some(function(b){return b instanceof Text?b.parentNode===a:b===a||d(b).has(a).length})})};k.prototype._matchAttributeFilter=function(a){return this.attributeFilter&&this.attributeFilter.length?0<=this.attributeFilter.indexOf(a.attributeName):!0};var n=function(a){this.patterns=[];this._target=
a;this._observer=null};n.prototype.observe=function(a,b,c){var d=this;this._observer?this._observer.disconnect():this._observer=new t(function(a){a.forEach(function(a){d.patterns.forEach(function(b){var c=b.match(a);c.length&&c.each(function(){b.handler.call(this,a)})})})});this.patterns.push(new k(this._target,a,b,c));this._observer.observe(this._target,this._collapseOptions())};n.prototype.disconnect=function(a,b,c){var d=this;this._observer&&(this.patterns.filter(function(d){return d.is(a,b,c)}).forEach(function(a){a=
d.patterns.indexOf(a);d.patterns.splice(a,1)}),this.patterns.length||this._observer.disconnect())};n.prototype.disconnectAll=function(){this._observer&&(this.patterns=[],this._observer.disconnect())};n.prototype.pause=function(){this._observer&&this._observer.disconnect()};n.prototype.resume=function(){this._observer&&this._observer.observe(this._target,this._collapseOptions())};n.prototype._collapseOptions=function(){var a={};this.patterns.forEach(function(b){var c=a.attributes&&a.attributeFilter;
if(!c&&a.attributes||!b.attributeFilter)c&&b.options.attributes&&!b.attributeFilter&&delete a.attributeFilter;else{var e={},f=[];(a.attributeFilter||[]).concat(b.attributeFilter).forEach(function(a){e[a]||(f.push(a),e[a]=1)});a.attributeFilter=f}d.extend(a,b.options)});Object.keys(m).forEach(function(b){delete a[m[b]]});return a};var p=function(a){this.patterns=[];this._paused=!1;this._target=a;this._events={};this._handler=this._handler.bind(this)};p.prototype.NS=".jQueryObserve";p.prototype.observe=
function(a,b,c){a=new k(this._target,a,b,c);d(this._target);a.options.childList&&(this._addEvent("DOMNodeInserted"),this._addEvent("DOMNodeRemoved"));a.options.attributes&&this._addEvent("DOMAttrModified");a.options.characterData&&this._addEvent("DOMCharacerDataModified");this.patterns.push(a)};p.prototype.disconnect=function(a,b,c){var e=d(this._target),f=this;this.patterns.filter(function(d){return d.is(a,b,c)}).forEach(function(a){a=f.patterns.indexOf(a);f.patterns.splice(a,1)});var g=this.patterns.reduce(function(a,
b){b.options.childList&&(a.DOMNodeInserted=!0,a.DOMNodeRemoved=!0);b.options.attributes&&(a.DOMAttrModified=!0);b.options.characterData&&(a.DOMCharacerDataModified=!0);return a},{});Object.keys(this._events).forEach(function(a){g[a]||(delete f._events[a],e.off(a+f.NS,f._handler))})};p.prototype.disconnectAll=function(){var a=d(this._target),b;for(b in this._events)a.off(b+this.NS,this._handler);this._events={};this.patterns=[]};p.prototype.pause=function(){this._paused=!0};p.prototype.resume=function(){this._paused=
!1};p.prototype._handler=function(a){if(!this._paused){var b={type:null,target:null,addedNodes:null,removedNodes:null,previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null};switch(a.type){case "DOMAttrModified":b.type="attributes";b.target=a.target;b.attributeName=a.attrName;b.oldValue=a.prevValue;break;case "DOMCharacerDataModified":b.type="characterData";b.target=d(a.target).parent().get(0);b.attributeName=a.attrName;b.oldValue=a.prevValue;break;case "DOMNodeInserted":b.type=
"childList";b.target=a.relatedNode;b.addedNodes=[a.target];b.removedNodes=[];break;case "DOMNodeRemoved":b.type="childList",b.target=a.relatedNode,b.addedNodes=[],b.removedNodes=[a.target]}for(a=0;a<this.patterns.length;a++){var c=this.patterns[a],e=c.match(b);e.length&&e.each(function(){c.handler.call(this,b)})}}};p.prototype._addEvent=function(a){this._events[a]||(d(this._target).on(a+this.NS,this._handler),this._events[a]=!0)};q.Pattern=k;q.MutationObserver=n;q.DOMEventObserver=p;d.fn.observe=
function(a,b,c){b?c||(c=b,b=null):(c=a,a=f);return this.each(function(){var e=d(this),f=e.data("observer");f||(f=t?new n(this):new p(this),e.data("observer",f));a=g(a);f.observe(a,b,c)})};d.fn.disconnect=function(a,b,c){a&&(b?c||(c=b,b=null):(c=a,a=f));return this.each(function(){var e=d(this),f=e.data("observer");f&&(a?(a=g(a),f.disconnect(a,b,c)):(f.disconnectAll(),e.removeData("observer")))})}})(jQuery,jQuery.Observe);

// Search overlay functionality
$(document).ready(function() {
    var searchTimeout;
    var currentHighlighted = -1;
    
    // Search icon click handler
    $('.search-icon-wrapper').on('click', function() {
        openSearchOverlay();
    });
    
    
    // Close with Escape key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            closeSearchOverlay();
        }
    });
    
    // Search input functionality
    $('#search-input').on('input', function() {
        var query = $(this).val().trim();
        
        clearTimeout(searchTimeout);
        
        if (query.length < 2) {
            $('#search-suggestions').hide();
            return;
        }
        
        // Debounce search requests
        searchTimeout = setTimeout(function() {
            searchProducts(query);
        }, 300);
    });
    
    // Handle keyboard navigation
    $('#search-input').on('keydown', function(e) {
        var $suggestionItems = $('#search-suggestions .search-suggestion-item');
        
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            currentHighlighted = Math.min(currentHighlighted + 1, $suggestionItems.length - 1);
            updateHighlight($suggestionItems);
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            currentHighlighted = Math.max(currentHighlighted - 1, -1);
            updateHighlight($suggestionItems);
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (currentHighlighted >= 0 && $suggestionItems.eq(currentHighlighted).length) {
                var productUrl = $suggestionItems.eq(currentHighlighted).data('url');
                if (productUrl) {
                    window.location.href = productUrl;
                }
            } else {
                performSearch($(this).val());
            }
        }
    });
    
    // Suggestion item click handler - open product page directly
    $(document).on('click', '.search-suggestion-item', function() {
        var productUrl = $(this).data('url');
        if (productUrl) {
            window.location.href = productUrl;
        }
    });
    
    // Search icon click handler
    $('#search-submit-icon').on('click', function() {
        var query = $('#search-input').val();
        if (query.trim()) {
            performSearch(query);
        }
    });
    
    // Close button click handler
    $('#search-close-button').on('click', function() {
        closeSearchOverlay();
    });
    
    function openSearchOverlay() {
        var $overlay = $('#search-overlay');
        
        $overlay.addClass('show').css('display', 'block');
        $('body').css('overflow', 'hidden'); // Prevent scrolling
        $('#search-close-button').show(); // Show close button
        
        // Focus on input after a small delay to ensure overlay is visible
        setTimeout(function() {
            $('#search-input').focus();
        }, 100);
    }
    
    function closeSearchOverlay() {
        $('#search-overlay').removeClass('show').css('display', 'none');
        $('body').css('overflow', ''); // Restore scrolling
        $('#search-suggestions').hide();
        $('#search-close-button').hide(); // Hide close button
        currentHighlighted = -1;
    }
    
    function updateHighlight($items) {
        $items.each(function(index) {
            $(this).toggleClass('highlighted', index === currentHighlighted);
        });
    }
    
    function selectSuggestion(suggestion) {
        $('#search-input').val(suggestion);
        performSearch(suggestion);
    }
    
    function performSearch(query) {
        if (query.trim()) {
            window.location.href = '/search?q=' + encodeURIComponent(query.trim());
            // + '&type=product';
        }
    }
    
    function searchProducts(query) {
        var $suggestions = $('#search-suggestions');
        
        $.ajax({
            url: '/search/suggest.json',
            data: {
                q: query,
                'resources[type]': 'product',
                'resources[limit]': 8
            },
            dataType: 'json',
            success: function(data) {
                if (data.resources && data.resources.results && data.resources.results.products) {
                    displaySuggestions(data.resources.results.products);
                } else {
                    $suggestions.hide();
                }
            },
            error: function() {
                console.error('Search error');
                $suggestions.hide();
            }
        });
    }
    
    function displaySuggestions(products) {
        var $suggestions = $('#search-suggestions');
        currentHighlighted = -1;
        
        if (products.length === 0) {
            $suggestions.hide();
            return;
        }
        
        var suggestionsHtml = products.map(function(product) {
            var productUrl = product.url || '/products/' + product.handle;
            return '<div class="search-suggestion-item" data-url="' + productUrl + '">' + product.title + '</div>';
        }).join('');
        
        $suggestions.html(suggestionsHtml).show();
    }
});